import { View } from 'backbone.marionette';
// import { Model } from "backbone";
import moment from "moment";
import template from './index.jst'

export class MatchCentreMatch extends View {
	get tagName() {
		return 'li';
	}

	get template() {
		return template;
	}

	initialize() {
		const match = this.model.toJSON(),
			is_live = match.status === 'playing'
		;
		let time = null;

		if (is_live && match.clock && match.clock.s !== -1) {
			time = match.clock.p + ' | ' + this.getReadableDate(match.clock.s);
		}

		this.model.set({
			image_squads_path: process.env.SQUAD_LOGOS_PATH,
			inited: true,
			game_date: moment(match.date).format('h:mma'),
			is_scheduled: match.status === 'scheduled',
			is_completed: match.status === 'complete',
			is_live,
			time
		});
	}

	getReadableDate(seconds = 0) {
		let min = parseInt(seconds / 60, 10),
			sec = seconds - min * 60;
		if (min < 10) {
			min = '0' + min;
		}
		if (sec < 10) {
			sec = '0' + sec;
		}

		return min + ':' + sec;
	}


}

export default MatchCentreMatch;